import { Block, isArrayContainerBlock, isSingleContainerBlock, WidgetContent } from '../types';

/**
 * Get the number of loaded items for the specified Block.
 * Only available for ArrayContainerBlock and SingleContainer blocks.
 * */
export const getBlockResultsLength = (block?: WidgetContent & Block): number => {
    if (block && isArrayContainerBlock(block)) {
        return block.items?.length || 0;
    }
    if (block && isSingleContainerBlock(block)) {
        return getBlockResultsLength(block.container);
    }

    return 0;
};
